// extracted by mini-css-extract-plugin
export default {"root":"OrdersFilters_root__-qqFT"};